import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {  ProjectInterface, ProjectInterfaceWithId } from '@sk/sk-interfaces';
import {  Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { LocalStorageService } from 'services/local-storage.service';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as moment from 'moment';
import  firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private firestoreService: AngularFirestore,
              private storageService: LocalStorageService) {}


  // NGRX RELATED FUNCTIONS
  queryStateChangesProjects() {
    console.log(`RUN PROJECTS QUERY - ${moment().format('HH:mm:ss')}`);
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection<ProjectInterface>('projects')
      .stateChanges()
      .pipe(
        finalize(() => console.log('PROJECTS QUERY DONE'))
      )
  }



  addProjectByNgrx(projectData: ProjectInterfaceWithId) : Observable<ProjectInterfaceWithId> {
    const organizationId = this.storageService.getOrganizationId();
    const newProjectObj = {
      ...projectData
    };
    if (newProjectObj.id) {
      delete newProjectObj.id;
    }
    if (newProjectObj.exists) {
      delete newProjectObj.exists;
    }
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('projects').add(newProjectObj))
      .pipe(
        map(res => {
          const exists = true;
          const id = res.id;
          return {...projectData, id, exists,  } as ProjectInterfaceWithId;
        }));
  }


  updateProjectByIdWithNGRX(projectData: ProjectInterfaceWithId, id: string) : Observable<ProjectInterfaceWithId> {
    const organizationId = this.storageService.getOrganizationId();
    const updateProjectObj = {
      ...projectData
    };
    if (updateProjectObj.id) {
      delete updateProjectObj.id;
    }
    if (updateProjectObj.exists) {
      delete updateProjectObj.exists;
    }
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('projects').doc(id).update(updateProjectObj))
      .pipe(
        map(() => {
          const exists = true;
          const location = {...projectData, id, exists  } as ProjectInterfaceWithId;
          return location;
        }));
  }


  /**
   * Returns all projects for an Organization, used by the scheduling
   * module
  **/
  getProjects(filterValue: string = 'all', subscription: string = 'all'): Observable<ProjectInterfaceWithId[]> {
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection('projects', ref => {
        let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
        query = query.orderBy('name', 'asc')
        if (filterValue !== 'all') {
          query = (filterValue === 'active') ? query.where('active', '==', true) : query.where('active', '==', false)
        }
        if (subscription !== 'all') {
          query = (subscription === 'true') ? query.where('subscription', '==', true) : query.where('subscription', '==', false)
        }
        return query;
      })
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as ProjectInterface;
          let prepayPlan = null
          if(data.prepayPlan){
            prepayPlan = data.prepayPlan
          }
          const exists = a.payload.doc.exists;
          const id = a.payload.doc.id;
          return {...data, prepayPlan, id, exists} as ProjectInterfaceWithId;
        }))
      );
  }




  getProject(id: string): Observable<ProjectInterfaceWithId> {
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection('projects').doc(id).get()
      .pipe(
        map(res => {
          const project = res.data() as ProjectInterface;
          const exists = res.exists;
          let prepayPlan = null
          if(project.prepayPlan){
            prepayPlan = project.prepayPlan
          }
          const newProject = {...project, id, exists, prepayPlan  } as ProjectInterfaceWithId;
          return newProject;
      }));
  }

  // TODO: If you haven't done a get yet then you won't be able to update the cache
  addProject(project: ProjectInterface) {
    const organizationId = this.storageService.getStorage('organizationId');
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('projects').add(project))
      .pipe(
        map(res => {
              const id = res.id;
              const exists = true;
              const newProject = {...project, id, exists,  } as ProjectInterfaceWithId;
              return newProject;
            }));
  }

  updateProject(project, projectId: string) {
    const organizationId = this.storageService.getStorage('organizationId');
    const projectUpdate = {
      ...project
    };
    delete projectUpdate.id;
    delete projectUpdate.exists;
    return fromPromise(
      this.firestoreService
        .collection('organizations').doc(organizationId)
        .collection('projects').doc(projectId).update(projectUpdate))
        .pipe(
          map(() => {
                const id = projectId;
                const exists = true;
                const newProject = {...project, id, exists,  } as ProjectInterfaceWithId;
                return newProject;
              }));;
  }


}
